<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 100px)">
    <el-table-column label="序号" type="index" width="100">
    </el-table-column>
    <el-table-column prop="OptDate" label="操作日期">
    </el-table-column>
    <el-table-column prop="OptTime" label="操作时间">
    </el-table-column>
    <el-table-column prop="TransferMoney" :label="'提现金额（' + CurrencyName + '）'">
    </el-table-column>
    <el-table-column prop="Id" label="提现流水号">
    </el-table-column>
    <el-table-column prop="OrderState" label="状态">
    </el-table-column>
    <el-table-column prop="AuditRemark" label="审核意见" show-overflow-tooltip>
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
      </template>
    </el-table-column>
    <el-dialog title="查看详情" :visible.sync="dialogVisible" append-to-body width="80%">
      <div class="infobox clearfix">
          <div class="infoboxinfo">
              <span>提现金额:</span>
              <input type="text" v-model="obj.TransferMoney"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>提现流水号:</span>
              <input type="text" v-model="obj.Id"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>操作日期:</span>
              <input type="text" v-model="obj.OptDate"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>操作时间:</span>
              <input type="text" v-model="obj.OptTime"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>状态:</span>
              <input type="text" v-model="obj.OrderState"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>汇率:</span>
              <input type="text" v-model="obj.ExchangeRate"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>实到{{CurrencyName}}:</span>
              <input type="text" v-model="obj.TransferMoneyFact"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>实到人民币:</span>
              <input type="text" v-model="obj.LocalMoneyFact"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>{{CurrencyName}}手续费:</span>
              <input type="text" v-model="obj.TransferMoneyFee"  disabled>
          </div>
          <div class="infoboxinfo">
              <span>人民币手续费:</span>
              <input type="text" v-model="obj.LocalMoneyFee"  disabled>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-table>
</template>

<script>
export default {
  // 提现记录表格
  name: "withdrawalRecordT",
  data() {
    return {
      obj: {},
      dialogVisible: false,
      CurrencyName: '',
    };
  },
  props: ["data"],
  created() {
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.obj = row;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/withdrawalRecord/withdrawalRecordT.vue